import CompaniesComponent from "../components/companies/CompaniesComponent";

export default function Companies() {
  return (
    <CompaniesComponent />
  )
}
